""// StaffProfilePDF.js
import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
  Image
} from '@react-pdf/renderer';

Font.register({
  family: 'Roboto',
  fonts: [
    { src: 'https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu4mxP.ttf' },
    { src: 'https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmWUlfBBc9.ttf', fontWeight: 700 },
  ]
});

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontFamily: 'Roboto',
    fontSize: 10,
    lineHeight: 1.5,
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 700,
    marginBottom: 10,
    textAlign: 'center',
  },
  userSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    border: '1px solid black',
    padding: 10,
    marginBottom: 10,
  },
  userDetails: {
    flex: 3,
    paddingRight: 10,
  },
  profileImage: {
    width: 100,
    height: 120,
    objectFit: 'cover',
    borderRadius: 4,
    border: '1px solid #ccc',
  },
  fieldRow: {
    flexDirection: 'row',
    marginBottom: 4,
  },
  fieldLabel: {
    width: 100,
    fontWeight: 700,
  },
  fieldValue: {
    flex: 1,
  },
  tableContainer: {
    marginTop: 10,
    border: '1px solid black',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#f0f0f0',
    borderBottom: '1px solid black',
    padding: 5,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottom: '1px solid #ccc',
    padding: 5,
  },
  cell: {
    flex: 1,
    textAlign: 'center',
  },
  footer: {
    position: 'absolute',
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: 'center',
    fontSize: 8,
    color: 'grey',
  },
});

const StaffProfilePDF = ({ userDetails = {}, quizSummary = [] }) => (
  <Document>
    <Page size="A4" style={styles.page} wrap>
      <Text style={styles.sectionTitle}>Staff Profile</Text>

      {/* Profile Info */}
      <View style={styles.userSection}>
        <View style={styles.userDetails}>
          <View style={styles.fieldRow}><Text style={styles.fieldLabel}>Name:</Text><Text style={styles.fieldValue}>{userDetails.firstName} {userDetails.lastName}</Text></View>
          <View style={styles.fieldRow}><Text style={styles.fieldLabel}>Role:</Text><Text style={styles.fieldValue}>{userDetails.role}</Text></View>
          <View style={styles.fieldRow}><Text style={styles.fieldLabel}>Employee ID:</Text><Text style={styles.fieldValue}>{userDetails.employeeId}</Text></View>
          <View style={styles.fieldRow}><Text style={styles.fieldLabel}>NRIC / FIN:</Text><Text style={styles.fieldValue}>{userDetails.nricOrFin || 'N/A'}</Text></View>
          <View style={styles.fieldRow}><Text style={styles.fieldLabel}>Mobile:</Text><Text style={styles.fieldValue}>{userDetails.countryCode} {userDetails.mobileNo}</Text></View>
          <View style={styles.fieldRow}><Text style={styles.fieldLabel}>Email:</Text><Text style={styles.fieldValue}>{userDetails.emailId}</Text></View>
        </View>
        <View>
          {userDetails.profileImage && (
            <Image style={styles.profileImage} src={userDetails.profileImage} />
          )}
        </View>
      </View>

      {/* Quiz Summary Table */}
      <Text style={{ fontWeight: 700, fontSize: 12, marginTop: 10 }}>Quiz Summary</Text>
      <View style={styles.tableContainer}>
        <View style={styles.tableHeader}>
          <Text style={[styles.cell, { flex: 0.5 }]}>#</Text>
          <Text style={styles.cell}>Exam</Text>
          <Text style={styles.cell}>Attempt</Text>
          <Text style={styles.cell}>Status</Text>
          <Text style={styles.cell}>Marks</Text>
          <Text style={styles.cell}>Grade</Text>
        </View>
        {quizSummary.length > 0 ? quizSummary.map((summary, index) => {
          const state = JSON.parse(summary.state || '{}');
          const examName = summary.examName?.[0]?.name || 'N/A';
          return (
            <View key={index} style={styles.tableRow}>
              <Text style={[styles.cell, { flex: 0.5 }]}>{index + 1}</Text>
              <Text style={styles.cell}>{examName}</Text>
              <Text style={styles.cell}>{summary.attempt}</Text>
              <Text style={styles.cell}>{summary.grade >= 70 ? 'Pass' : 'Fail'}</Text>
              <Text style={styles.cell}>{summary.mark}/{summary.noOfQuestions}</Text>
              <Text style={styles.cell}>{summary.grade} %</Text>
            </View>
          );
        }) : (
          <View style={styles.tableRow}>
            <Text style={{ flex: 1, textAlign: 'center' }}>No quiz records available.</Text>
          </View>
        )}
      </View>

      {/* Footer */}
      <Text style={styles.footer} render={({ pageNumber, totalPages }) => (
        `Page ${pageNumber} of ${totalPages}`
      )} fixed />
    </Page>
  </Document>
);

export default StaffProfilePDF;